import styled, { css } from 'styled-components';

import { ReactComponent as YesIconBase } from 'assets/icons/yes.svg';
import { ReactComponent as NoIconBase } from 'assets/icons/no.svg';

const availableIconStyles = css`
  display: flex;
  align-items: center;
`;

export const YesIcon = styled(YesIconBase)`
  ${availableIconStyles};
`;

export const NoIcon = styled(NoIconBase)`
  ${availableIconStyles};
`;

export const BlockadeWrapper = styled.div`
  display: flex;
  gap: 8px;
  align-items: center;
`;
